import styled from "styled-components";
import Colors from "assets/Colors.js";

const ForgotText = styled.a`
  font-size: 12px;
  font-weight: 400;
  display: flex;
  justify-content: end;
  margin-top: 9px;
  margin-bottom: 10px;
  color: ${Colors.ORANGELOGIN};
`;

const line = styled.div`
  border-bottom: 1px solid ${Colors.greyOutline};
  width: 70%;
  marginbottom: 20px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Title = styled.div`
  font-size: 22px;
  font-weight: 700;
  font-height: 120%;
  margin-bottom: 32px;
`;

const TitleLeft = styled.div`
  font-size: 21px;
  font-weight: 700;
  font-height: 120%;
  color: white;
`;

const SubTitleRight = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
`;

const SubTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 24px;
  margin-bottom: 5px;
`;

const NoAccountText = styled.div`
  margin-top: 29px;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  /* font-family: SF Pro Text; */
`;

const formContainer = styled.div`
  // min-height: 100vh;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const form = styled.div`
  width: 50%;
  margin-top: 120px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 916px) {
    width: 100%;
    padding: 0 24px;
  }
`;

const headerContainer = styled.div`
  width: 80%;
  height: 70px;
  position: absolute;
  right: 0;
  left: 0;
  margin: auto;
  z-index: 100;
  padding: 20px 0px 0 0px;
  display: flex;
  justify-content: space-between;
  color: white;
  @media (max-width: 768px) {
    width: 100%;
    padding: 40px 24px 0px;
  }
`;

const imageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: end;
  height: 45vh;
  margin-top: 120px;
  @media (max-width: 900px) {
    height: auto;
  }
`;

const textContainer = styled.div`
  height: 20%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  // margin-bottom: 70px;
`;

const Remember = styled.a`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: ${Colors.text_primary};
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  /* font-family: SF Pro Text; */
`;

const joinUp = styled.a`
  margin-top: -10px;
  margin-bottom: 20px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: ${Colors.text_secondary};
`;

const register = styled.a`
  color: ${Colors.primary};
`;

const ErrorText = styled.div`
  color: ${Colors.notification_failed};
  font-size: 12px;
  font-weight: 400;
  margin-top: 10px;
  height: 14px;
  visibility: ${(props) => (props.visible ? "visible" : "hidden")};
`;

export default {
  ForgotText,
  line,
  Title,
  TitleLeft,
  SubTitleRight,
  SubTitle,
  NoAccountText,
  formContainer,
  form,
  headerContainer,
  imageContainer,
  textContainer,
  Remember,
  joinUp,
  register,
  ErrorText,
};
